import { FC, ReactElement } from 'react';
import { ChatProvider } from 'state/contexts/ChatContext/ChatContext';
import { ModalProvider } from 'state/contexts/modalContext/modalContext';
import { NotificationProvider } from 'state/contexts/NotificationContext/NotificationContext';
import { StorageRequestProvider } from 'state/contexts/storageRequestContext/storageRequest.context';
import { TwilioProvider } from 'state/contexts/TwilioContext/TwilioContext';
import { UserProvider } from 'state/contexts/userContext/userContext';

const AppWrapper: FC<{ children: ReactElement }> = ({ children }) => (
  <UserProvider>
    <StorageRequestProvider>
      <TwilioProvider>
        <ChatProvider>
          <NotificationProvider>
            <ModalProvider>{children}</ModalProvider>
          </NotificationProvider>
        </ChatProvider>
      </TwilioProvider>
    </StorageRequestProvider>
  </UserProvider>
);

export default AppWrapper;
